import { GetterTree } from "vuex";
import { IFavouriteFilterState } from "./favourite-filter-states.store";
import favouriteFilterTypesStore from "./favourite-filter-types.store";
const favouriteGetters: GetterTree<IFavouriteFilterState, {}> = <
  GetterTree<IFavouriteFilterState, {}>
>{
  /** GETTER: GET LIST FAVOURITES */
  [favouriteFilterTypesStore.Getter.GET_LIST_FAVOURITES]: (
    state: IFavouriteFilterState
  ) => {
    return state.favouriteFilters || [];
  },

  // Property
  [favouriteFilterTypesStore.Getter.GET_LIST_PROPERTY_FAVOURITES]: (
    state: IFavouriteFilterState
  ) => {
    return state.propertyfavouriteFilters || [];
  },

  // Client
  [favouriteFilterTypesStore.Getter.GET_LIST_PERSON_FAVOURITES]: (
    state: IFavouriteFilterState
  ) => {
    return state.personfavouriteFilters || [];
  },

  // Demand
  [favouriteFilterTypesStore.Getter.GET_LIST_DEMAND_FAVOURITES]: (
    state: IFavouriteFilterState
  ) => {
    return state.demandfavouriteFilters || [];
  },

  // Task
  [favouriteFilterTypesStore.Getter.GET_LIST_TASK_FAVOURITES]: (
    state: IFavouriteFilterState
  ) => {
    return state.taskfavouriteFilters || [];
  },

  [favouriteFilterTypesStore.Getter.GET_CURRENT_FAVOURITE]: (
    state: IFavouriteFilterState
  ) => {
    return state.currentFavourite || null;
  },

  // Property
  [favouriteFilterTypesStore.Getter.GET_CURRENT_PROPERTY_FAVOURITE]: (
    state: IFavouriteFilterState
  ) => {
    return state.currentPropertyFavourite || null;
  },
  [favouriteFilterTypesStore.Getter.GET_ORIGINAL_PROPERTY_FAVOURITE]: (
    state: IFavouriteFilterState
  ) => {
    return state.originalPropertyFavourite || null;
  },

  // Demand
  [favouriteFilterTypesStore.Getter.GET_CURRENT_DEMAND_FAVOURITE]: (
    state: IFavouriteFilterState
  ) => {
    return state.currentDemandFavourite || null;
  },
  [favouriteFilterTypesStore.Getter.GET_ORIGINAL_DEMAND_FAVOURITE]: (
    state: IFavouriteFilterState
  ) => {
    return state.originalDemandFavourite || null;
  },

  // Client
  [favouriteFilterTypesStore.Getter.GET_CURRENT_PERSON_FAVOURITE]: (
    state: IFavouriteFilterState
  ) => {
    return state.currentPersonFavourite || null;
  },
  [favouriteFilterTypesStore.Getter.GET_ORIGINAL_PERSON_FAVOURITE]: (
    state: IFavouriteFilterState
  ) => {
    return state.originalPersonFavourite || null;
  },

  // Task
  [favouriteFilterTypesStore.Getter.GET_CURRENT_TASK_FAVOURITE]: (
    state: IFavouriteFilterState
  ) => {
    return state.currentTaskFavourite || null;
  },
  [favouriteFilterTypesStore.Getter.GET_ORIGINAL_TASK_FAVOURITE]: (
    state: IFavouriteFilterState
  ) => {
    return state.originalTaskFavourite || null;
  },

  /** GETTER: GET CURRENT REQUEST MODEL */
  [favouriteFilterTypesStore.Getter.GET_CURRENT_REQUEST_MODEL]: (
    state: IFavouriteFilterState
  ) => {
    return state.currentRequestModel || null;
  },

  /** GETTER: GET FAVOURITES SERVICE  */
  [favouriteFilterTypesStore.Getter.GET_FAVOURITES_SERVICE]: (
    state: IFavouriteFilterState
  ) => {
    return state.service || [];
  }
};

export default favouriteGetters;
